<template>
  <div class="right-content">
    <!-- 增加新功能提示 -->
    <InformationUp ref="informationUp" />
    <!-- AI 助手 -->
    <AiAssistantDrawer ref="AiAssistantDrawer" />

    <a
      v-if="showGuideBtn"
      class="right-content__action right-content__action--btn"
      @click="SCMGuild"
    >
      <icon-font
        type="gb-icon-zidingyiguanlix"
      style="margin-right: 5px; color: inherit"
      />
      初始化引导
    </a>
    <!-- activeKey{{activeKey}} -->
    <!-- 邮件营销 -->
    <!-- <EmailMarketing v-if="systemCode === 'ERP'"></EmailMarketing> -->
    <!-- 系统切换 -->
    <!-- !isDemo && subjectMode !== 1 -->
    <!-- <system-change v-if="!isDemo" :systems="systems"></system-change> -->
    <!-- 菜单变身 ** 只有ERP进来才有 -->
    <!-- <menu-transform v-if="systemCode === 'ERP'"></menu-transform> -->
    <!-- 版本切换 -->
    <!-- !isDemo && subjectMode !== 1 && userConfig.packageStyle === '1' && Number(currentSystem.subTab) < 6 && systemCode === 'ERP' -->
    <version-change
      v-if="
        !isDemo &&
        userConfig.packageStyle === '1' &&
        currentSystem &&
        Number(currentSystem.subTab) < 6 &&
        systemCode === 'ERP'
      "
    />
    <!-- 帮助中心 -->
    <!-- <a-tooltip :title="i18nRender('layouts.helpcenter')" v-if="userConfig.packageStyle === '1'">
      <a class="right-content__action" v-demo="'openHelpCenter'">
        <icon-font type="gb-icon-helper-circle" />
      </a>
    </a-tooltip>-->
    <!-- 引爆增长 -->
    <!-- <DetonateGrowth v-if="!isDemo && systemCode === 'ERP'"></DetonateGrowth> -->
    <!-- 资金助手 -->
    <!-- <a-tooltip :title="i18nRender('layouts.MoneyAssistant')" v-if="!isDemo && isAppear" :trigger="['hover']">
      <a class="right-content__action" @click="toMoneyAssistant" style="margin-left: 12px">
        <icon-font type="gb-icon-zijinzhushou" />
      </a>
    </a-tooltip> -->
    <!-- 直播 -->
    <a-button
      v-if="broadcastMessage"
      class="right-content__action right-content__action--btn"
      type="primary"
      size="small"
      style="background-color: #1e5af9;border-color: #1e5af9;color: #fff;"
      @click="openNotification"
    >
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="9.6px"
        height="12px"
        viewBox="0 0 24 30"
        style="
          enable-background: new 0 0 50 50;
          vertical-align: middle;
          margin-right: 0.5rem;
        "
        xml:space="preserve"
      >
        <rect x="0" y="13" width="4" height="5" fill="#fff">
          <animate
            attributeName="height"
            attributeType="XML"
            values="5;21;5"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="y"
            attributeType="XML"
            values="13; 5; 13"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          ></animate>
        </rect>
        <rect x="10" y="13" width="4" height="5" fill="#fff">
          <animate
            attributeName="height"
            attributeType="XML"
            values="5;21;5"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="y"
            attributeType="XML"
            values="13; 5; 13"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          ></animate>
        </rect>
        <rect x="20" y="13" width="4" height="5" fill="#fff">
          <animate
            attributeName="height"
            attributeType="XML"
            values="5;21;5"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="y"
            attributeType="XML"
            values="13; 5; 13"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          ></animate>
        </rect>
      </svg>
      直播
    </a-button>
    <!-- AI助手 -->
    <a-button
      class="right-content__action right-content__action--btn"
      type="primary"
      size="small"
      style="background-color: #1e5af9;border-color: #1e5af9;color: #fff;"
      @click="showAIAssistant"
    >
      {{ $t('header_ai_assistant') }}
    </a-button>
    <!-- 新功能 -->
    <a-button
      class="right-content__action right-content__action--btn"
      type="primary"
      size="small"
      style="background-color: #28a864;border-color: #28a864;color: #fff;"
      @click="showNewFunction"
    >
      新功能
    </a-button>
    <a-tooltip v-if="showProdAIImage" :title="'亚马逊AI全能助手，用麦多，越卖越多'">
      <a class="right-content__action" @click="showProdAIAssistant">
        <img
          src="@/assets/px-logo.png"
          alt="麦多AI"
          style="margin-right: 5px;width: 16.8px;"
        />
        <span style="color: #fff;font-size: 16px;font-weight: 600;">麦多AI</span>
      </a>
    </a-tooltip>
    <!-- 应用市场 -->
    <!-- <a class="right-content__action" style="margin-left: 15px;"  v-demo="'openAppMarketplace'" v-if="!isDemo && systemCode === 'ERP'">
      <icon-font style="margin-right: 4px;" type="gb-icon-app-marketplace" v-if="userConfig.packageStyle === '1'" />
      <span style=" padding-right: 0">{{ $t('layouts.应用市场') }}</span>
      <span class="safe-new" v-if="localDefaultConfig.appNew" ></span>
    </a> -->
    <!-- 导出中心 -->
    <a-popover
      overlayClassName="export-center-entry-head-drop-overlay"
      placement="bottomRight"
      :visible="visibleDownlodaCenter"
      :trigger="visibleDownlodaCenter ? 'click' : 'hover'"
    >
      <template slot="content">
        <p
          style="width: 200px;height: 70px;font-weight: bold;margin-top: 10px;color: #fff;"
        >
          {{ i18nRender("layouts.exportcenterhere") }}
        </p>
        <a-button
          type="primary"
          style="position: absolute;right: 10px;bottom: 10px;overflow: hidden;background: #1e5af9;color: #fff;"
          @click="handleKnow"
        >
          {{ i18nRender("common_btn_i_know") }}
        </a-button>
      </template>
      <a-tooltip :title="i18nRender('layouts.exportcenter')">
        <span class="right-content__action" @click="viewExportCenter">
          <svg
            t="1723550081342"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8917"
            data-spm-anchor-id="a313x.manage_type_myprojects.0.i2.32193a81iPrHDr"
            width="16"
            height="16"
            fill="currentColor"
          >
            <path
              d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64z m19.2 156.032c7.04 0 12.8 5.76 12.8 12.8v379.136h113.92a12.8 12.8 0 0 1 9.408 21.44L521.408 793.6a12.8 12.8 0 0 1-18.88 0l-145.92-160.192a12.8 12.8 0 0 1 9.536-21.44H480V232.832c0-7.04 5.76-12.8 12.8-12.8h38.4z"
              p-id="8918"
            ></path>
          </svg>
        </span>
      </a-tooltip>
    </a-popover>
    <!-- 消息提醒 -->
    <NewsList v-if="!isDemo && isNote" />
    <!-- 客服系统 -->
    <a-tooltip :title="i18nRender('layouts.onlineservice')">
      <a
        v-demo="'getQueryList'"
        class="right-content__action"
        href="javascript:;"
      >
        <icon-font type="gb-icon-kefu" />
      </a>
    </a-tooltip>
    <!-- 语言切换 -->
    <!-- <SelectLang /> -->
    <!---客服系统入口--->
    <ServiceEnter v-if="!isYST_user" :getQueryList="getQueryList" />
    <!-- 用户信息 -->
    <AvatarDropdown />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { i18nRender } from '@/locales'
import { findPane } from '@/store/_util/util'

import AvatarDropdown from './AvatarDropdown'
import NewsList from './NewsList'
import VersionChange from './VersionChange'
import ServiceEnter from '@/components/Tips/ServiceEnter'
import InformationUp from '@/components/Tips/informationUp'
import AiAssistantDrawer from './modal/AiAssistantDrawer'

import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'

import { QuerySystemParamsPage, forward, stTopSaledGoods } from '@/api'
import { retryTask, getDownloadDetail } from '@/api/downloadcenter'

export default {
  name: "RightContent",
  components: {
    InformationUp,
    AvatarDropdown,
    NewsList,
    VersionChange,
    ServiceEnter,
    AiAssistantDrawer
  },
  props: {
    subjectMode: {
      type: [Number, Object],
      default: () => null,
    },
  },
  data () {
    const userInfo = this.$ls.get(USER_INFO)
    return {
      visibleDownlodaCenter: false,
      downloadCenterMap: {},
      userInfo,
      url: '',
      isFlag: false,
      MoneyAssistantUrl: '',
      isAppear: false,
      showProdAIImage: true
    }
  },
  computed: {
    ...mapGetters([
      'serviceId',
      'systemCode',
      'userConfig',
      'isDemo',
      'microApps',
      'panes',
      'menus',
      'activeKey',
      'systems',
      'currentSystem',
      'localDefaultConfig',
      'broadcastMessage'
    ]),
    isNote () {
      const found = findPane(this.menus, {
        menuUrl: '/company/notice/notification',
        systemCode: 'SSO_SYS_USER'
      })
      return found
    },
    isYST_user () {
      return (
        this.userInfo?.classification === 'YST_PLUS'
      )
    },
    showGuideBtn () {
      const erp = this.systems.find((item) => item.systemCode === 'ERP')
      if (erp) {
        const activeTime = new Date(erp.serviceActive).getTime()
        return (
          activeTime > new Date('2023-12-15T00:00:00.000+0800').getTime() &&
          this.userInfo?.classification &&
          ['TIKTOK', 'SAIL'].includes(this.userInfo.classification)
        )
      }
      return false
    }
  },
  methods: {
    i18nRender,
    handleKnow () {
      this.visibleDownlodaCenter = false
    },
    handleShowPopver () {
      const hasShow = localStorage.getItem('showDownloadCenterFlag')
      if (!hasShow) {
        this.visibleDownlodaCenter = true
        localStorage.setItem('showDownloadCenterFlag', true)
      }
    },
    showNewFunction () {
      this.$refs.informationUp.getLastAnnouncement()
    },
    viewExportCenter () {
      const {
        params: { serviceId, systemCode }
      } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        ignore: true,
        menuName: {
          zh_CN: '导出中心',
          en_US: 'Export Center'
        },
        path: `/entry/${serviceId}/${systemCode}/universal_system#/download-center`
      })
    },
    async getQueryList () {
      const { systemCode } = this.$route.params
      try {
        const params = {
          paging: false,
          systemGroup: 'ECS_CUSTOMER_CONFIG'
        }
        const { dataList } = await QuerySystemParamsPage(params)
        for (const v of dataList) {
          if (v.status === 2 && v.systemName === systemCode) {
            this.isFlag = true
            this.url = v.systemValue
          }
        }
        if (this.isFlag) {
          this.openSale1()
        } else {
          this.openSaleConsult()
        }
      } catch (error) {
        console.log(error)
      }
    },
    openSale1 () {
      let menuName = ''
      this.panes.forEach((v, i) => {
        if (v.key === this.activeKey) {
          menuName = v.tab
        }
      })
      const params = {
        token: this.$ls.get(ACCESS_TOKEN),
        menuId: this.activeKey,
        menuName
      }
      const found = findPane(this.menus, { key: this.activeKey }, null, [
        'systemCode'
      ])

      if (found && typeof found.systemCode !== 'undefined') {
        params.systemCode = found.systemCode
      }
      const URL = `${this.url}?${Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&')}`
      window.open(URL, '_blank')
    },
    openSaleConsult () {
      const { systemCode } = this.$route.params
      this.$store.dispatch('OpenSaleConsult', systemCode)
    },
    openHelpCenter () {
      const { systemCode } = this.$route.params
      this.$winOpen(`/#/company/helper/center?helpSystemCode=${systemCode}`)
    },
    toMoneyAssistant () {
      window.open(this.MoneyAssistantUrl, '_blank')
    },
    openAppMarketplace () {
      this.$store.dispatch('SetLocalDefaultConfig', {
        appNew: false
      })
      const {
        params: { serviceId, systemCode }
      } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/app/home`
      })
    },
    closeAndToDownloadCenter (data) {
      return () => {
        this.$notification.close(data)
        if (this.downloadCenterMap[data] !== 'success') {
          this.downloadCenterMap[data] = 'cancel'
        }
        this.viewExportCenter()
      }
    },
    showDownloadSuccessTip (data, url, name) {
      this.$notification.close(data)
      const key = `success_${Date.now()}`
      this.downloadCenterMap[data] = 'success'
      this.handleShowPopver()
      this.$notification.success({
        key,
        duration: 6000,
        message: '下载文件准备完成',
        style: {
          top: this.visibleDownlodaCenter ? '134px' : '20px'
        },
        onClose: () => {
          this.$notification.close(key)
          this.downloadCenterMap[data] = 'cancel'
        },
        description: this.$createElement('div', [
          this.$createElement('span', [
            `【${name}】你可以选择"立即下载"或稍后在`,
            this.$createElement('a', {
              style: { textDecoration: 'underline' },
              on: { click: () => this.closeAndToDownloadCenter(key)() }
            }, '导出中心'),
            '查看'
          ])
        ]),
        btn: (h) => {
          return h(
            'a-button',
            {
              style: {
                background: '#077bfc',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                padding: '2px 8px'
              },
              props: {
                size: 'small'
              },
              on: {
                click: () => {
                  window.location.href = url
                  this.$notification.close(key)
                }
              }
            },
            '立即下载'
          )
        }
      })
    },
    showDownloadingTip (data) {
      this.handleShowPopver()
      this.$notification.open({
        zIndex: 100,
        key: data,
        duration: 6000,
        style: {
          top: this.visibleDownlodaCenter ? '134px' : '20px'
        },
        message: '下载文件准备中',
        onClose: () => {
          this.$notification.close(data)
          this.downloadCenterMap[data] = 'cancel'
        },
        description: this.$createElement('div', [
          this.$createElement('span', [
            '准备工作会在后台进行，你可以选择进行其他操作或稍后前往',
            this.$createElement('a', {
              style: { textDecoration: 'underline' },
              on: { click: () => this.closeAndToDownloadCenter(data)() }
            }, '导出中心'),
            '查看'
          ])
        ]),
        icon: this.$createElement('a-icon', {
          style: { color: '#077bfc' },
          props: { type: 'loading' }
        })
      })
    },
    handleTaskProcess (data, time = 2500) {
      setTimeout(() => {
        getDownloadDetail(data).then((res) => {
          if (
            ['处理中', '未开始'].includes(res.data.status) &&
            res.data.is_del !== 1
          ) {
            if (!this.downloadCenterMap[data]) {
              this.downloadCenterMap[data] = 'doing'
              this.showDownloadingTip(data)
            }
            if (this.downloadCenterMap[data] === 'doing') {
              this.handleTaskProcess(data)
            }
          } else if (res.data.status === '已完成') {
            this.showDownloadSuccessTip(
              data,
              res.data.fileOssUrl,
              res.data.name
            )
          } else if (res.data.status === '处理失败') {
            this.showDownloadingErrorTip(data, res.data.name)
          } else {
            this.$notification.close(data)
            this.downloadCenterMap[data] = 'cancel'
          }
        })
      }, time)
    },
    showDownloadingErrorTip (data, name) {
      this.$notification.close(data)
      const key = `error_${Date.now()}`
      this.$notification.error({
        duration: 6000,
        key,
        message: '导出文件失败',
        onClose: () => {
          this.$notification.close(key)
          this.downloadCenterMap[data] = 'cancel'
        },
        description: this.$createElement('div', [
          this.$createElement('span', [
            `[${name}]导出失败，你可以选择"重试"`
          ])
        ]),
        btn: (h) => {
          return h(
            'a-button',
            {
              style: {
                background: '#077bfc',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                padding: '2px 8px'
              },
              props: {
                size: 'small'
              },
              on: {
                click: () => {
                  this.$notification.close(key)
                  retryTask(data).then(() => {
                    this.downloadCenterMap[data] = undefined
                    this.handleTaskProcess(data)
                  })
                }
              }
            },
            '重试'
          )
        }
      })
    },
    initDownloadCenter () {
      window.addEventListener('message', ({ data }) => {
        if (data && data.id === 'downloadCenterHelper') {
          this.handleTaskProcess(data.data, 0)
        }
        if (data && data.id === 'initSCMPanelHelper') {
          this.initSCMPanel(data.data)
        }
      })
    },
    initSCMPanel (path = '/guide') {
      console.log(path, '---')
      const {
        params: { serviceId, systemCode }
      } = this.$route
      this.$store
        .dispatch('entry/findPane', {
          systemCode: 'SCM_NEW',
          menuUrl: path
        })
        .then((pane) => {
          this.$store.dispatch('entry/Navigator', pane)
        })
        .catch(() => {
          this.$store.dispatch('entry/Navigator', {
            key: 'scm_new_guide',
            systemCode: 'SCM_NEW',
            path: `/entry/${serviceId}/${systemCode}/scm_new#${path}`,
            menuName: {
              zh_CN: '初始化引导',
              en_US: '初始化引导',
              ko_KR: '初始化引导'
            },
            noCache: true,
            ignore: true,
            closable: true
          })
        })
    },
    SCMGuild () {
      const { microApps } = this
      const {
        params: { serviceId, systemCode }
      } = this.$route

      if (~microApps.findIndex((item) => item.systemCode === 'SCM_NEW')) {
        this.initSCMPanel()
      } else {
        const systemDomain =
          process.env.NODE_ENV === 'production'
            ? 'https://scm-web-new.eccang.com'
            : 'https://test-scm-web-new.eccang.com'
        const url = '/guide'
        this.$store.dispatch('entry/Navigator', {
          key: 'scm_new_guide',
          systemDomain: systemDomain,
          menuUrl: systemDomain + url,
          menuName: {
            zh_CN: '初始化引导',
            en_US: '初始化引导',
            ko_KR: '初始化引导'
          },
          path: `/entry/${serviceId}/${systemCode}/iframe#/guide`,
          noCache: true,
          ignore: true,
          closable: true
        })
      }
    },
    openNotification () {
      const {
        params: { serviceId, systemCode }
      } = this.$route
      const { broadcastMessage } = this

      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/live-roadcast/details?liveId=${broadcastMessage.liveId}`
      })
    },
    showProdAIAssistant () {
      try {
        const token = JSON.parse(localStorage.getItem('pro__Access-Token')).value || ''
        const companyCode = JSON.parse(localStorage.getItem('pro__company_id'))?.value || ''
        const url = `https://ai.maiduox.com/#/tools/maiduo-agent?token=${encodeURIComponent(token)}&companyCode=${encodeURIComponent(companyCode)}`
        window.open(url, '_blank')
      } catch (e) {
        window.open('https://ai.maiduox.com', '_blank')
      }
    },
    showAIAssistant () {
      this.$refs.AiAssistantDrawer.open()
    },
    async checkProdAIImageVisibility () {
      try {
        const params = {
          company_code: JSON.parse(localStorage.getItem('pro__company_id'))?.value || ''
        }
        const result = await stTopSaledGoods(params)
        this.showProdAIImage = result?.data?.is_set !== 0
      } catch (error) {
        console.error('获取ProdAI图片显示状态失败:', error)
        this.showProdAIImage = true
      }
    }
  },
  mounted () {
    this.initDownloadCenter()
    forward({}).then((res) => {
      if (res.data) {
        const data = JSON.parse(res.data?.respBody || '{}')
        this.MoneyAssistantUrl = data?.url || ''
        if (data?.authStatus === 1) {
          this.isAppear = true
        }
      }
    })

    this.$store.dispatch('getLivingBroadcast', this)

    this.checkProdAIImageVisibility()
  }
};
</script>

<style lang="less">
.entry-head-drop-overlay {
  & > .@{ant-prefix}-popover-content {
    & > .@{ant-prefix}-popover-arrow {
      transform: translateY(-13px) rotate(45deg);
    }
  }
  .@{ant-prefix}-popover-inner {
    padding: 0;
    min-width: 200px;
    margin-top: -14px;
    position: relative;
    .@{ant-prefix}-popover-inner-content {
      padding: 4px 0;
    }
    .@{ant-prefix}-menu {
      border-right: none;
    }
  }
}
.export-center-entry-head-drop-overlay {
  & > .@{ant-prefix}-popover-content {
    & > .@{ant-prefix}-popover-arrow {
      transform: translate(13px, -13px) rotate(45deg);
    }
  }
  .@{ant-prefix}-popover-inner {
    margin-top: -14px;
    position: relative;
    .@{ant-prefix}-menu {
      border-right: none;
    }
  }
}
</style>
<style lang="less" scoped>
.right-content {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 42px;
  line-height: 42px;
}

.right-content__action {
  display: inline-flex;
  color: #ffffff;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
  align-items: center;
  position: relative;

  &:hover {
    color: #1890ff;
  }

  > span {
    display: inline-block;
    max-width: 8em;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
  }

  .anticon {
    font-size: 1.3em;
    vertical-align: middle;
    // color: #fff;
  }
  .safe-new {
    position: relative;
    top: -5px;
    font-size: 12px;
    margin-left: -10px;
    margin-top: -8px;
    color: #fff;
    background: #ff001b;
    height: 16px;
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
    border-radius: 20px;
    &::before {
      content: "new";
      transform: translate(0, -2px);
    }
  }
}

.right-content__action--btn {
  padding: 0 8px;
  background-color: #ffffff;
  border-radius: 4px;
  color: #000;
  font-size: 12px;
  height: 24px;
  line-height: 24px;
}
</style>
